import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeatureFactsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 145,
	height: 145,
	viewBox: "0 0 145 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M72.3954 143.435C111.63 143.435 143.435 111.629 143.435 72.395C143.435 33.1607 111.63 1.35498 72.3954 1.35498C33.1611 1.35498 1.35547 33.1607 1.35547 72.395C1.35547 111.629 33.1611 143.435 72.3954 143.435Z",
			stroke: "white",
			strokeWidth: 2.71,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.085 71.4649C113.755 48.8549 94.1453 30.5149 70.7853 30.5149C47.4253 30.5149 28.4854 48.8549 28.4854 71.4649C28.4854 94.0749 47.4253 112.415 70.7853 112.415",
			stroke: "white",
			strokeWidth: 6.01,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.3454 53.4549C71.5932 53.4549 73.4154 51.6327 73.4154 49.3849C73.4154 47.1371 71.5932 45.3149 69.3454 45.3149C67.0976 45.3149 65.2754 47.1371 65.2754 49.3849C65.2754 51.6327 67.0976 53.4549 69.3454 53.4549Z",
			fill: "white",
			stroke: "white",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.335 103.755L93.075 117.575C93.075 117.575 96.745 95.2949 113.095 85.9949",
			stroke: "white",
			strokeWidth: 6.01,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.8057 61.9849C60.8057 61.9849 70.7957 61.0949 70.7957 71.4649V88.8749",
			stroke: "white",
			strokeWidth: 6.01,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.5254 88.875H82.6254",
			stroke: "white",
			strokeWidth: 6.01,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFeatureFactsIcon;
